import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useMemo } from "react";
import ddosIcon from "src/assets/images/security_ddos.svg";
import doubleSignIcon from "src/assets/images/security_double_sign.svg";
import downTimeIcon from "src/assets/images/security_down_time.svg";
import lowLatencyIcon from "src/assets/images/security_low_latency.svg";
import upgradeIcon from "src/assets/images/security_upgrade.svg";
import wetez_governance from "src/assets/images/wetez_governance.svg";
import {
  StakingSecurityItem,
  StakingSecurityModel,
} from "./StakingSecurityItem";
import arrow_right from "src/assets/images/Arrow_right.svg"

export const StakingSecurity = () => {
  const securityItems: StakingSecurityModel[] = useMemo(() => {
    return [
      {
        icon: doubleSignIcon,
        title: "Doublesign",
        descriptionTexts: ["Key management", "Server control", "Know rules"],
      },
      {
        icon: downTimeIcon,
        title: "Downtime",
        descriptionTexts: [
          "7x24 online",
          "Monitor by a deamon",
          "Self-restart when crash",
        ],
      },
      {
        icon: wetez_governance,
        title: "Vote",
        descriptionTexts: ["Be active in community", "Vote in time"],
      },
      {
        icon: lowLatencyIcon,
        iconPy: "13px",
        title: "Low Latency",
        descriptionTexts: ["Better performance server", "Suitable bandwidth"],
      },
      {
        icon: ddosIcon,
        title: "DDoS Resistance",
        descriptionTexts: ["Sentinel-node", "Securer firewall"],
      },
      {
        icon: upgradeIcon,
        title: "Upgrade in time",
        descriptionTexts: ["Upgrade protocol", "Fix compatibility"],
      },
    ];
  }, []);

  return (
    <Box p="50px 40px 60px">

      <Box display="flex" alignItems="center">
        <img src={arrow_right} style={{ width: "36px", height: "36px", marginRight: "10px" }} />
        <Typography fontSize="30px" variant="bold" color="#FFFFFF">
          Security
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography fontSize="16px" color="secondary" mt="15px">
          How Wetez secure the network and prevent service from potential loss, like downtime, slash, etc.
        </Typography>

      </Box>

      <Box
        mt="40px"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          rowGap: "50px",
          justifyContent: "space-around",
        }}
      >
        {securityItems.map((item) => (
          <StakingSecurityItem key={item.title} model={item} />
        ))}
      </Box>
    </Box>
  );
};
